import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { NodeOptionsObject } from "@app/workflow-common/diagram-view2/models/node.model";
import { Subject } from "rxjs";
var AuditHistory2Component = /** @class */ (function () {
    function AuditHistory2Component(_workflowHttpService) {
        this._workflowHttpService = _workflowHttpService;
        this.isLoading = true;
        this.noData = true;
        this.isLoadingDiagramView = false;
        this.currentPage = 1;
        this.pageLimit = 20;
        this.totalEntriesCount = 0;
        this.auditItems = [];
        this.param = {};
        this.fields = {};
        this.infiniteScrollOn = false;
        this.selectedItem = undefined;
        this.activeDagData = undefined;
        this.filterOptions = [];
        this.appliedViewsFilter = [];
        this.widthChangeEventSubject = new Subject();
        this.workflowId = undefined;
        this.voidCallingOnInit = true;
    }
    AuditHistory2Component.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.dagSourceModel = new DagSourceModel();
                        this.dagSourceModel.setFieldMetadata(this.metaData.fields);
                        return [4 /*yield*/, this.getData(true)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.fields = this.dagSourceModel.getFieldMetadata();
                        this.nodeOptions = new NodeOptionsObject({
                            title: this.metaData.title,
                            showAddChild: false,
                            isDraftMode: false,
                            autosave: false,
                            workflowId: this.workflowId,
                            metaData: this.metaData,
                            viewMode: 'audit'
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AuditHistory2Component.prototype.getData = function (resetPage) {
        var _this = this;
        if (resetPage === void 0) { resetPage = false; }
        return new Promise(function (resolve) {
            if (resetPage) {
                _this.currentPage = 1;
            }
            _this.param = {
                page: _this.currentPage,
                limit: _this.pageLimit
            };
            _this.param['filter'] = _this.appliedViewsFilter;
            _this._workflowHttpService.getAutomationAuditList(_this.workflowId, _this.param).subscribe(function (data) {
                if (data.hasOwnProperty('items')) {
                    _this.auditItems = data['items'];
                    _this.totalEntriesCount = data['totalCount'];
                    _this.filterOptions = data['defaultFilters'];
                }
                if (_this.totalEntriesCount > 0) {
                    _this.noData = false;
                }
                resolve(true);
            });
        });
    };
    AuditHistory2Component.prototype.applyFilters = function (filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.appliedViewsFilter.push(filter);
                        return [4 /*yield*/, this.getData(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuditHistory2Component.prototype.removeFilter = function (filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.appliedViewsFilter.splice(filter, 1);
                        return [4 /*yield*/, this.getData(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuditHistory2Component.prototype.onScrollEnd = function (event) {
        var _this = this;
        if (this.voidCallingOnInit) {
            this.voidCallingOnInit = false;
            return;
        }
        if (this.infiniteScrollOn) {
            return;
        }
        if (this.totalEntriesCount == this.auditItems.length) {
            return;
        }
        this.infiniteScrollOn = true;
        this.currentPage = this.currentPage + 1;
        this.param = {
            page: this.currentPage,
            limit: this.pageLimit
        };
        this._workflowHttpService.getAutomationAuditList(this.workflowId, this.param).subscribe(function (data) {
            if (data.hasOwnProperty('items')) {
                _this.auditItems = _this.auditItems.concat(data['items']);
                _this.infiniteScrollOn = false;
            }
        });
    };
    AuditHistory2Component.prototype.showDiagramPreview = function (item) {
        var _this = this;
        console.log('item', item);
        this.selectedItem = item;
        this.isLoadingDiagramView = true;
        this._workflowHttpService.getAutomationAuditDetail(item.id)
            .subscribe(function (resp) {
            _this.activeDagData = resp['data'];
            _this.nodeOptions.audit = {
                taskId: _this.activeDagData['taskId'],
                eventId: _this.activeDagData['eventType'],
            };
            _this.isLoadingDiagramView = false;
        });
    };
    return AuditHistory2Component;
}());
export { AuditHistory2Component };
